<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="4" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yd-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">预订服务</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">预订服务</div>
        <div class="f17 ls3">Reservation Services</div>
      </div>
    </div>
    <div class="spot-cont mt-40 pb100">
      <div class="spot-tit df align_center justify_center">
        <h2 class="f32 foo pb15">在线购票</h2>
      </div>
      <div class="df align_center justify_center flex_column w1000 auto pt50 pb100 bgwh mt20" v-if="data && data.Items && data.Items.length > 0">
        <div class="f18 b tc" v-if="data.Items[0].Remark">{{ data.Items[0].Remark }}</div>
        <img v-if="data.Items[0].Photo" :src="data.Items[0].Photo" class="db mt50" width="500" height="500" alt="">
      </div>
      <!-- <div class="df align_center justify_center flex_column w1000 auto pt50 pb100 bgwh mt20">
        <div class="f18 b tc">请使用微信"扫一扫"以下小程序码进行购票</div>
        <img src="@/assets/images/mp-ticket.png" class="db mt50" width="500" alt="">
      </div> -->
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-ydfw-zxgp',
      data: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data;
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/yuding/index.vue